module.exports = __webpack_public_path__ + "static/dc-2a915e8897221b685ef827436d91b590.png";